import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";

export interface ShinseiInfo {
  id: number;
  shinseiId: string; //申請ID
  statusCd: string; //ステータスコード
  statusNm: string; //ステータス
  kigyonaiShinchokuCdShinsei: string; //企業内進捗コード_申請
  kigyonaiShinchokuNmShinsei: string; //企業内進捗_申請
  kigyonaiShinchokuCdShonin: string; //企業内進捗コード_承認
  kigyonaiShinchokuNmShonin: string; //企業内進捗_承認

  gyoushuCd: string; //業種分類コード
  gyoushuNm: string; //業種分類名
  kaishaCd: string; //会社コード
  kaishaNm: string; //会社名
  kaishaGroupId: string; //会社グループID
  kaishaGroupNm: string; //会社グループ名

  torokuAccountId: string; //登録_アカウントID
  torokuKjnNm: string; //登録_個人名
  torokuBushoNm: string; //登録_部署名
  kanriAccountId: string; //管理_アカウントID
  kanriKjnNm: string; //管理_個人名
  kanriBushoNm: string; //管理_部署名

  shoninTorokuAccountId: string; //ULT承認_登録_アカウントID
  shoninTorokuTantoNm: string; //ULT承認_登録_担当者名
  shoninKanriAccountId: string; //ULT承認_管理_アカウントID
  shoninKanriTantoNm: string; //ULT承認_管理_担当者名

  itakusakiKaishaNm: string; //申請_委託先_会社名
  itakusakiJusho: string; //申請_委託先_住所
  saiItakusakiKaishaNm: string; //申請_再委託先_会社名
  saiItakusakiJusho: string; //申請_再委託先_住所
  riyoBasho: string; //申請_利用場所
  kikanKaishibi: string | Date | null; //申請_期間_開始日
  kikanShuryobi: string | Date | null; //申請_期間_終了日
  riyomokuteki: string; //申請_利用目的
  riyohoho: string; //申請_利用方法
  riyohaniDcfFlg: boolean; //申請_利用範囲_DCF_フラグ
  riyohaniDsfFlg: boolean; //申請_利用範囲_DSF_フラグ
  riyohaniDnfFlg: boolean; //申請_利用範囲_DNF_フラグ
  riyohaniEcfFlg: boolean; //申請_利用範囲_ECF_フラグ
  riyohaniPcfFlg: boolean; //申請_利用範囲_PCF_フラグ
  riyohaniSonohokaFlg: boolean; //申請_利用範囲_その他_フラグ
  riyohaniSonohokaText: string; //申請_利用範囲_その他_テキスト
  riyokomokuKjnCdFlg: boolean; //申請_利用項目_個人コード_フラグ
  riyokomokuKjnNmFlg: boolean; //申請_利用項目_個人名_フラグ
  riyokomokuShiCdFlg: boolean; //申請_利用項目_施設コード_フラグ
  riyokomokuShiNmFlg: boolean; //申請_利用項目_施設名_フラグ
  riyokomokuShiJushoFlg: boolean; //申請_利用項目_施設住所_フラグ
  riyokomokuShiTelFlg: boolean; //申請_利用項目_施設電話番号_フラグ
  riyokomokuSrkmFlg: boolean; //申請_利用項目_診療科目_フラグ
  riyokomokuSzbkFlg: boolean; //申請_利用項目_所属部科_フラグ
  riyokomokuSonohokaFlg: boolean; //申請_利用項目_その他_フラグ
  riyokomokuSonohokaText: string; //申請_利用項目_その他_テキスト
  shinseiComment: string; //申請_コメント
  shoninComment: string; //申請_コメント
  shinseiBunruiCd: string; //申請分類コード
  shinseiBunruiNm: string; //申請分類
  doiCheck: boolean; //同意チェック

  torokuDate: string; //登録日時
  koshinDate: string; //更新日時
  shinseiDate: string; //申請日時
  shoninDate: string; //承認日時
}

export type ShinseiList = Pick<
  ShinseiInfo,
  | "id"
  | "shinseiId"
  | "statusCd"
  | "statusNm"
  | "kigyonaiShinchokuNmShinsei"
  | "kigyonaiShinchokuNmShonin"
  | "kikanKaishibi"
  | "kikanShuryobi"
  | "kaishaNm"
  | "kaishaGroupNm"
  | "torokuKjnNm"
  | "torokuBushoNm"
  | "itakusakiKaishaNm"
  | "saiItakusakiKaishaNm"
  | "riyomokuteki"
  | "torokuDate"
  | "koshinDate"
>;
export type ExcelForShoninsha = Omit<ShinseiInfo, "id" | "doiCheck">;
export type ExcelForShinseisha = Pick<
  ShinseiInfo,
  | "shinseiId"
  | "statusNm"
  | "kigyonaiShinchokuNmShinsei"
  | "kaishaNm"
  | "kaishaGroupNm"
  | "torokuKjnNm"
  | "torokuBushoNm"
  | "kanriKjnNm"
  | "kanriBushoNm"
  | "itakusakiKaishaNm"
  | "itakusakiJusho"
  | "saiItakusakiKaishaNm"
  | "saiItakusakiJusho"
  | "riyoBasho"
  | "kikanKaishibi"
  | "kikanShuryobi"
  | "riyomokuteki"
  | "riyohoho"
  | "riyohaniDcfFlg"
  | "riyohaniDnfFlg"
  | "riyohaniDsfFlg"
  | "riyohaniEcfFlg"
  | "riyohaniPcfFlg"
  | "riyohaniSonohokaFlg"
  | "riyohaniSonohokaText"
  | "riyokomokuKjnCdFlg"
  | "riyokomokuKjnNmFlg"
  | "riyokomokuShiCdFlg"
  | "riyokomokuShiNmFlg"
  | "riyokomokuShiJushoFlg"
  | "riyokomokuShiTelFlg"
  | "riyokomokuSrkmFlg"
  | "riyokomokuSzbkFlg"
  | "riyokomokuSonohokaFlg"
  | "riyokomokuSonohokaText"
  | "shinseiComment"
  | "shoninTorokuTantoNm"
  | "shoninKanriTantoNm"
  | "shoninComment"
  | "torokuDate"
  | "koshinDate"
>;

export const Prop2LabelMap = {
  id: "ID",
  shinseiId: "申請ID",
  statusCd: "ステータスコード",
  statusNm: "ステータス",
  kigyonaiShinchokuCdShinsei: "企業内進捗コード_申請",
  kigyonaiShinchokuNmShinsei: "企業内進捗_申請",
  kigyonaiShinchokuCdShonin: "企業内進捗コード_承認",
  kigyonaiShinchokuNmShonin: "企業内進捗_承認",
  gyoushuCd: "業種分類コード",
  gyoushuNm: "業種分類名",
  kaishaCd: "会社コード",
  kaishaNm: "会社名",
  kaishaGroupId: "会社グループID",
  kaishaGroupNm: "会社グループ名",
  torokuAccountId: "登録_アカウントID",
  torokuKjnNm: "登録者名",
  torokuBushoNm: "登録者部署名",
  kanriAccountId: "管理_アカウントID",
  kanriKjnNm: "管理_個人名",
  kanriBushoNm: "管理_部署名",
  shoninTorokuAccountId: "ULT承認_登録_アカウントID",
  shoninTorokuTantoNm: "ULT承認_登録_担当者名",
  shoninKanriAccountId: "ULT承認_管理_アカウントID",
  shoninKanriTantoNm: "ULT承認_管理_担当者名",
  itakusakiKaishaNm: "申請_委託先会社名",
  itakusakiJusho: "申請_委託先住所",
  saiItakusakiKaishaNm: "申請_再委託先会社名",
  saiItakusakiJusho: "申請_再委託先住所",
  riyoBasho: "申請_利用場所",
  kikanKaishibi: "申請_開始日",
  kikanShuryobi: "申請_終了日",
  riyomokuteki: "申請_利用目的",
  riyohoho: "申請_利用方法",
  riyohaniDcfFlg: "申請_利用範囲_DCF_フラグ",
  riyohaniDsfFlg: "申請_利用範囲_DSF_フラグ",
  riyohaniDnfFlg: "申請_利用範囲_DNF_フラグ",
  riyohaniEcfFlg: "申請_利用範囲_ECF_フラグ",
  riyohaniPcfFlg: "申請_利用範囲_PCF_フラグ",
  riyohaniSonohokaFlg: "申請_利用範囲_その他_フラグ",
  riyohaniSonohokaText: "申請_利用範囲_その他_テキスト",
  riyokomokuKjnCdFlg: "申請_利用項目_個人コード_フラグ",
  riyokomokuKjnNmFlg: "申請_利用項目_個人名_フラグ",
  riyokomokuShiCdFlg: "申請_利用項目_施設コード_フラグ",
  riyokomokuShiNmFlg: "申請_利用項目_施設名_フラグ",
  riyokomokuShiJushoFlg: "申請_利用項目_施設住所_フラグ",
  riyokomokuShiTelFlg: "申請_利用項目_施設電話番号_フラグ",
  riyokomokuSrkmFlg: "申請_利用項目_診療科目_フラグ",
  riyokomokuSzbkFlg: "申請_利用項目_所属部科_フラグ",
  riyokomokuSonohokaFlg: "申請_利用項目_その他_フラグ",
  riyokomokuSonohokaText: "申請_利用項目_その他_テキスト",
  shinseiComment: "申請_コメント",
  shoninComment: "承認_コメント",
  shinseiBunruiCd: "申請分類コード",
  shinseiBunruiNm: "申請分類",
  doiCheck: "同意チェック",
  torokuDate: "登録日時",
  koshinDate: "更新日時",
  shinseiDate: "申請日時",
  shoninDate: "承認日時",
};
export const tableHeader: TableHeaderConfig[] = [
  {
    prop: "shinseiId",
    label: Prop2LabelMap.shinseiId,
    width: ColWidth.mini,
  },
  {
    prop: "statusNm",
    label: Prop2LabelMap.statusNm,
    width: ColWidth.sm,
  },
  {
    prop: "kigyonaiShinchokuNmShinsei",
    label: Prop2LabelMap.kigyonaiShinchokuNmShinsei.split("_")[0],
    width: ColWidth.sm,
  },
  {
    prop: "kigyonaiShinchokuNmShonin",
    label: Prop2LabelMap.kigyonaiShinchokuNmShonin.split("_")[0],
    width: ColWidth.sm,
  },
  {
    prop: "kikanKaishibi",
    label: Prop2LabelMap.kikanKaishibi.split("_")[1],
    width: ColWidth.mini,
  },
  {
    prop: "kikanShuryobi",
    label: Prop2LabelMap.kikanShuryobi.split("_")[1],
    width: ColWidth.mini,
  },
  {
    prop: "kaishaNm",
    label: Prop2LabelMap.kaishaNm,
  },
  {
    prop: "kaishaGroupNm",
    label: Prop2LabelMap.kaishaGroupNm,
  },
  {
    prop: "torokuKjnNm",
    label: Prop2LabelMap.torokuKjnNm,
  },
  {
    prop: "itakusakiKaishaNm",
    label: Prop2LabelMap.itakusakiKaishaNm.split("_")[1],
  },
  {
    prop: "torokuDate",
    label: Prop2LabelMap.torokuDate,
    width: ColWidth.lg,
  },
  {
    prop: "koshinDate",
    label: Prop2LabelMap.koshinDate,
    width: ColWidth.lg,
  },
];
export const tableExpand: TableHeaderConfig[] = [
  {
    prop: "torokuBushoNm",
    label: Prop2LabelMap.torokuBushoNm,
  },
  {
    prop: "riyomokuteki",
    label: Prop2LabelMap.riyomokuteki.split("_")[1],
  },
  {
    prop: "saiItakusakiKaishaNm",
    label: Prop2LabelMap.saiItakusakiKaishaNm.split("_")[1],
  },
];

//ボタン表示/loading動画制御用
export interface Buttons {
  shinseiBtn: boolean;
  kariShinseiBtn: boolean;
  kariShinseiOkBtn: boolean;
  copyBtn: boolean;
  saveBtn: boolean;
  deleteBtn: boolean;
  kariShinseiNgBtn: boolean;
  shoninBtn: boolean;
  kariShoninBtn: boolean;
  kariShoninOkBtn: boolean;
  horyuBtn: boolean;
  kariHoryuBtn: boolean;
  kariHoryuOkBtn: boolean;
  kariShoninNgBtn: boolean;
  kariHoryuNgBtn: boolean;
}
